<template>
  <div>
    <assessment />

    <warnings class="mt-3" />

    <display-document />
  </div>
</template>

<script>
import Assessment from '@/components/assessment/Assessment.vue';
import DisplayDocument from '@/components/displayDocument/DisplayDocument.vue';
import Warnings from '@/components/displayDocument/Warnings.vue';

// @vuese
// Szczegółowe dane dokumentu
export default { components: { Assessment, DisplayDocument, Warnings } };
</script>
